<template>
  <v-list-item v-if="node.create" exact dense :to="nodeRoute" :target="target">
    <v-list-item-icon v-if="!isChild && node.icon">
      <v-icon>{{ node.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ node.label }}</v-list-item-title>
      <v-list-item-subtitle></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="babel" type="text/babel">
import node from './node.js'
export default {
  mixins: [node],
  data: () => ({
    nodeRoute: null,
  }),
  mounted() {
    this.nodeRoute = window.eagleLodash.cloneDeep(this.route)
    this.init()
  },
  methods: {
    init() {
      if (!this.nodeRoute) {
        return
      }
      if (this.$helper.whereLayout() != "provider-store") {
        return
      }
      /**
       * url params有帶 providerId
       * 要在這裡更新
       * 因為menu.ts建立的階段layout ProviderId尚未初始化完成
       * 在這邊動態建立
       */
      if (this.hasProviderIdRouteParams) {
        this.nodeRoute.params.providerId = this.providerId
      }
    },
  },
  computed: {
    layoutProviderId() {
      return this.$store.getters["base/layoutProviderId"];
    },
    providerId() {
      return this.$route.params.providerId || this.layoutProviderId
    },
    target() {
      if(this.node.blank === true) return '_blank'
      return '_self'
    },
    nodeParamsProviderId() {
      if (!this.nodeRoute) return null
      if (!this.nodeRoute.params) return null
      return this.nodeRoute.params.providerId
    },
    hasProviderIdRouteParams() {
      if (!this.nodeRoute) return null
      if (!this.nodeRoute.params) return null
      return 'providerId' in this.nodeRoute.params
    },
    route() {
      if(typeof this.node.route != 'object') return null
      return this.node.route
    },
    active() {
      if(!this.route) return false
      if(typeof this.node.active === 'function') {
        return this.node.active(this.$route)
      }
      if(this.route.name != this.$route.name) return false
      if(window.eagleLodash.isEqual(this.route.params, this.$route.params)) return false
      return true
    },
  },
  watch: {
    active: {
      immediate: true,
      handler() {
        this.$emit('activeChange', this.active)
      }
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
